(function () {
    'use strict';

    a3_cabin_reports.factory('LogCallFactory', LogCallFactory);

    /**
     * @memberof CabinReports
     * @ngdoc factory
     * @name LogCallFactory
     * @ngInject
     */
    function LogCallFactory(GenericService, $http, apiUrl) {
        function LogCall() {
            this.Requester = null;
            this.Requestee = null;
			this.FlightId = null;
            this.GroundDutyId = null;
            this.Date = null;
		}
      
        var objType ='logCall';
		var objCallback = LogCall; 

        var service = {
            getLogCallsFromStorage : getLogCallsFromStorage,
            cleanLogsFromStorage : cleanLogsFromStorage,
            saveLogCall : saveLogCall
        };

         /**
         * Get Offline Logged Calls.
         * @memberof LogCallFactory
         */
		function getLogCallsFromStorage() {
			return GenericService.list(objType,objCallback);
		}

         /**
         * Clean local storage
         * @memberof CrewCallFactory
         */
		function cleanLogsFromStorage() {
            GenericService.removeAll(objType,objCallback);
        }


        /**
		 * Save an offline call request
         * @memberof CrewCallFactory
		 * @param {object} logData 
		 */
		function saveLogCall(logData){
            GenericService.add(logData, objType, objCallback);
		}

        return service;
    }
})();